<template>
    <a-drawer placement="right" :closable="false" :visible="showDrawer" @close="close" width="70%">
        <!-- 顶部信息 -->
        <div class="header font">
            <div class="header-top">
                <div class="avatar">
                    <a v-if="teacherDetail.imgUrl" target="originalFile" :href="teacherDetail.imgUrl"><img
                            class="teacher-left" :src="teacherDetail.imgUrl +
                                '?x-oss-process=image/resize,m_fill,h_120,w_120'
                                " /></a>
                    <a v-else><img class="teacher-left" src="/course_cover.png" /></a>
                </div>
                <div class="teacher">
                    <div class="name">
                        {{ teacherDetail.nickname }}
                    </div>
                    <div class="date">
                        于{{ createdTime | formatDate }}注册，
                        <span v-if="currentStatus == '审核通过' && reviewer">
                            通过审核时间：{{ operateTime | formatDate }}，审核方：{{ reviewer }}
                        </span>
                        <span v-else>最后审核状态：{{ currentStatus }}</span>
                    </div>
                </div>
                <div class="export" v-if="!readOnly">
                    <a-button type="primary" @click="edit()">修改</a-button>
                    <a-button type="primary" @click="del()">删除</a-button>
                    <a-button type="primary" v-if="teacherDetail.status == 3 || teacherDetail.status == 2"
                        @click="submit()">提交审核</a-button>
                </div>
                <a class="close" @click="close">
                    <img src="../../../../public/close.png" alt="" />
                </a>
            </div>
            <div class="header-bottom font">
                <div class="teacher-detail">
                    <div class="text">已注册（天）</div>
                    <div class="number">{{ dataInfo.registDays || 0 }}</div>
                </div>
                <div class="teacher-detail">
                    <div class="text">任课班级（个）</div>
                    <!-- <div class="number">{{ classPagination.total || 0 }}</div> -->
                    <div class="number">{{ dataInfo.classes || 0 }}</div>
                </div>
                <div class="teacher-detail">
                    <div class="text">出勤（课时）</div>
                    <div class="number">{{ dataInfo.totalAttendance || 0 }}</div>
                </div>
                <div class="teacher-detail">
                    <div class="text">评价数（人次）</div>
                    <div class="number">{{ dataInfo.evaluation || 0 }}</div>
                </div>
                <div class="teacher-detail">
                    <div class="text">平均评分</div>
                    <div class="number">
                        {{ parseFloat(dataInfo.avgRating) || 0 }}
                        <!-- <span v-if="true" :class="{ green: true }">↑</span>
              <span v-else :class="{ red: true }">↓</span>
              <span :class="{ green: true, red: !true }" style="margin-left: 4px">
                平均分4分
              </span> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- tab分页 -->
        <a-tabs default-active-key="1">
            <!-- 基本信息 -->
            <a-tab-pane key="1" tab="基本信息">
                <div class="tabs font">
                    <!-- 用户信息 -->
                    <div class="base-information">
                        <div class="avatar">
                            <a v-if="teacherDetail.imgUrl" target="originalFile" :href="teacherDetail.imgUrl"><img
                                    class="teacher-left" :src="teacherDetail.imgUrl +
                                        '?x-oss-process=image/resize,m_fill,h_120,w_120'
                                        " /></a>
                            <a v-else><img class="teacher-left" src="/course_cover.png" /></a>
                        </div>
                        <div class="information-box">
                            <div class="information">
                                <div>
                                    手机号：<span class="infor">{{
                                        teacherDetail.mobile
                                    }}</span>
                                </div>
                                <div>
                                    姓名：<span class="infor">{{ teacherDetail.nickname }}</span>
                                </div>
                                <div>
                                    性别：<span class="infor">{{
                                        teacherDetail.genderText
                                    }}</span>
                                </div>
                            </div>
                            <div class="information">
                                <div>
                                    单位名称：<span class="infor">{{
                                        teacherDetail.companyName
                                    }}</span>
                                </div>
                                <div>
                                    开户行：<span class="infor">{{
                                        teacherDetail.bankName
                                    }}</span>
                                </div>
                                <div>
                                    银行卡号：<span class="infor">{{
                                        teacherDetail.bankCardNo
                                    }}</span>
                                </div>
                            </div>
                            <div class="information">
                                <div>
                                    授课方向：<span class="infor">{{
                                        teacherDetail.teachingCategory
                                            ? teacherDetail.teachingCategory[0].text
                                            : ""
                                    }}</span>
                                </div>
                                <div>
                                    地区：<span class="infor">{{ teacherDetail.province }}</span>
                                </div>
                                <div>
                                    身份证号：
                                    <span class="infor" v-if="teacherDetail.cardNo">
                                        {{ teacherDetail.cardNo }}
                                    </span>
                                    <div v-else style="width: 200px"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 说课视频 -->
                    <a class="video" @click="showVideo" v-if="talkingVideoUrl">
                        <img src="../../../../public/play.png" alt="" />
                        查看说课视频
                    </a>
                    <a-modal title="说课视频" :visible="isVideo" :footer="null" @cancel="videoCancel"
                        v-if="talkingVideoUrl">
                        <video class="videoSize" controls="controls" ref="videoPlay"
                            :src="teacherDetail.talkingVideoUrl[0].fileUrl"></video>
                    </a-modal>
                    <a-divider></a-divider>
                    <!-- 简介 -->
                    <div class="introduction">
                        <div class="title">简介</div>
                        <p>{{ teacherDetail.intro || "暂无简介" }}</p>
                    </div>
                    <a-divider></a-divider>
                    <div class="in-item">
                        <div class="key">资质证照</div>
                        <div class="value">
                            <div class="item item-1">
                                <span class="key">身份证：</span>
                                <div class="img-box">
                                    <img :src="'/course_cover.png'" v-if="!teacherDetail.cardFrontUrl" />
                                    <a v-else target="originalFile" :href="teacherDetail.cardFrontUrl
                                        ? teacherDetail.cardFrontUrl
                                        : '/course_cover.png'
                                        "><img :src="teacherDetail.cardFrontUrl +
                                            '?x-oss-process=image/resize,m_pad,h_180,w_320,color_F0F0F0'
                                            " style="width: 320px; height: 180px" /></a>
                                    <img :src="'/course_cover.png'" v-if="!teacherDetail.cardBackUrl" />
                                    <a v-else target="originalFile" :href="teacherDetail.cardBackUrl
                                        ? teacherDetail.cardBackUrl
                                        : '/course_cover.png'
                                        "><img :src="teacherDetail.cardBackUrl +
                                            '?x-oss-process=image/resize,m_pad,h_180,w_320,color_F0F0F0'
                                            " /></a>
                                </div>
                            </div>

                            <div class="item item-1">
                                <span class="key">2寸免冠照片：</span>
                                <img v-if="!protraitPhotoUrl" :src="'/course_cover.png'" />
                                <a v-else target="protraitPhoto" :href="protraitPhotoUrl">
                                    <img :src="protraitPhotoUrl +
                                        '?x-oss-process=image/resize,m_pad,h_180,w_320,color_F0F0F0'
                                        " />
                                </a>
                            </div>
                            <div class="item item-1" style="display: flex; flex-wrap: wrap" v-if="teacherDetail.degreeCertificatList &&
                                teacherDetail.degreeCertificatList.length
                            ">
                                <span class="key">学位证与学历证：</span>
                                <a-table :columns="columns" :data-source="degreeCertificatList" :pagination="false"
                                    :bordered="false" :rowKey="getRowKey">
                                    <template slot="description" slot-scope="text">
                                        <div class="description">
                                            {{ text }}
                                        </div>
                                    </template>
                                    <template slot="text" slot-scope="text">
                                        <div class="description">
                                            {{ text }}
                                        </div>
                                    </template>
                                    <div slot="teaTeacherInfoDos" slot-scope="text">
                                        <a v-if="text.imgSrc0" target="degreeCertificatList" :href="text.imgSrc0"><img
                                                :src="text.imgSrc0 +
                                                    '?x-oss-process=image/resize,m_pad,h_45,w_80,color_F0F0F0'
                                                    " /></a>
                                        <img v-else :src="'/course_cover.png'" />
                                    </div>
                                    <div slot="teaTeacherInfoDos1" slot-scope="text">
                                        <a v-if="text.imgSrc1" target="degreeCertificatList" :href="text.imgSrc1"><img
                                                :src="text.imgSrc1 +
                                                    '?x-oss-process=image/resize,m_pad,h_45,w_80,color_F0F0F0'
                                                    " /></a>
                                        <img v-else :src="'/course_cover.png'" />
                                    </div>
                                </a-table>
                            </div>
                            <div class="item item-1">
                                <span class="key">健康证明：</span>
                                <div class="img-box">
                                    <img :src="'/course_cover.png'" v-if="!teacherDetail.healthCertificateUrl" />
                                    <a v-else v-for="item in teacherDetail.healthCertificateUrl" :key="item.id"
                                        target="originalFile" :href="item.fileUrl ? item.fileUrl : '/course_cover.png'">
                                        <img v-if="!item.fileUrl" :src="'/course_cover.png'" />
                                        <img v-else :src="item.fileUrl +
                                            '?x-oss-process=image/resize,m_pad,h_180,w_320,color_F0F0F0'
                                            " /></a>
                                </div>
                            </div>
                            <div class="item item-1">
                                <span class="key">老师资质证书：</span>
                                <div v-if="credentialUrls && credentialUrls.length" class="img-box">
                                    <a v-for="item in credentialUrls" :key="item.id" target="originalFile"
                                        :href="item.fileUrl ? item.fileUrl : '/course_cover.png'">
                                        <img v-if="item.fileUrl" :src="item.fileUrl +
                                            '?x-oss-process=image/resize,m_pad,h_180,w_320,color_F0F0F0'
                                            " /></a>
                                </div>
                                <div v-else class="img-box">
                                    <img :src="'/course_cover.png'" />
                                </div>
                            </div>
                            <div class="item item-1">
                                <span class="key">无犯罪记录证明：</span>
                                <div class="img-box">
                                    <img v-if="!noCriminalUrl" :src="'/course_cover.png'" />
                                    <a v-else target="originalFile"
                                        :href="noCriminalUrl ? noCriminalUrl : '/course_cover.png'">
                                        <img :src="noCriminalUrl +
                                            '?x-oss-process=image/resize,m_pad,h_180,w_320,color_F0F0F0'
                                            " /></a>
                                </div>
                            </div>
                            <div class="item item-1" style="margin-bottom: 16px;">
                                <span class="key">无犯罪记录证明有效期：</span>
                                <a-date-picker v-model="noCriminalDate" disabled placeholder="未填写" />
                            </div>
                            <div class="item item-1">
                                <span class="key">从业经验：</span>
                                <div class="img-box">
                                    <img :src="'/course_cover.png'" v-if="!teacherDetail.experience" />
                                    <a v-else v-for="item in teacherDetail.experience" :key="item.id"
                                        target="experience" :href="item.fileUrl ? item.fileUrl : '/course_cover.png'">
                                        <img :src="item.fileUrl +
                                            '?x-oss-process=image/resize,m_pad,h_180,w_320,color_F0F0F0'
                                            " /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <!-- 任课班级 -->
            <a-tab-pane key="2" tab="任课班级">
                <div class="tabs font">
                    <a-table :columns="classColumns" :data-source="classData" bordered rowKey="classId"
                        :pagination="classPagination" @change="classChange">
                        <template slot="operate" slot-scope="text, record">
                            <a @click="viewClassDetail(record)">
                                查看班级详情
                            </a>
                        </template>
                    </a-table>
                </div>
            </a-tab-pane>
            <!-- 出勤记录 -->
            <a-tab-pane key="3" tab="出勤记录">
                <div class="tabs font">
                    <div class="Attendances">
                        <div class="attend-data">
                            <p>出勤总课时</p>
                            <div class="attend-number">
                                {{ dataInfo.totalAttendance || 0 }}
                            </div>
                        </div>
                        <div class="attend-data">
                            <p>正常</p>
                            <div class="attend-number">
                                {{ dataInfo.normalAttendance || 0 }}
                            </div>
                        </div>
                        <div class="attend-data">
                            <p>正常出勤率</p>
                            <div class="attend-number" v-if="dataInfo.normalAttendance">
                                {{
                                    (
                                        dataInfo.normalAttendance / dataInfo.totalAttendance
                                    ).toFixed(4) *
                                    100 +
                                    "%"
                                }}
                            </div>
                            <div v-else class="attend-number">0%</div>
                        </div>
                    </div>
                    <a-table :columns="AttendancesColumns" :data-source="attendanceData"
                        :pagination="attendancePagination" bordered :rowKey="getRowKey" @change="attendanceChange">
                        <template slot="checkinStatusText" slot-scope="text, record">
                            <span :class="{
                                error: record.checkinStatus == -1,
                                waitting: record.checkinStatus == 0,
                            }">
                                <!-- {{ record.checkinStatus != -1 ? text : `异常(${text})` }} -->
                                {{ text }}
                            </span>
                        </template>
                        <template slot="operate" slot-scope="text, record">
                            <a @click="viewAttendanceDetail(record)">
                                查看详情
                            </a>
                        </template>
                    </a-table>
                </div>
            </a-tab-pane>
            <!-- 审核记录 -->
            <a-tab-pane key="4" tab="审核记录">
                <div class="tabs font">
                    <div class="in-item">
                        <div class="key">
                            老师审核
                            <span class="value ml30" :class="{
                                'exa2': teacherDetail.status == '2',
                                'exa1': teacherDetail.status == '1',
                                'exa4':
                                    teacherDetail.status == '4' || teacherDetail.status == '5',
                            }">{{
                                teacherDetail.status == "0"
                                    ? "待审核"
                                    : teacherDetail.status == "1"
                                        ? "审核通过"
                                        : teacherDetail.status == "2"
                                            ? "审核不通过"
                                            : teacherDetail.status == "4"
                                                ? "初审通过"
                                                : teacherDetail.status == "5"
                                                    ? "复审通过" 
                                                    : "待提交"
                            }}</span>
                        </div>
                        <div class="value">
                            <ul class="process">
                                <li class="process-item" v-for="item in checkOperateLogArr" :key="item.id">
                                    <span class="operate">{{ item.operateLog }}</span>
                                    <span :class="[
                                        item.stateAfter == 1
                                            ? 'exa1'
                                            : item.stateAfter == 2
                                                ? 'exa2'
                                                : item.stateAfter == 4 || item.stateAfter == 5
                                                    ? 'exa3'
                                                    : 'exa4'
                                    ]">
                                        {{ item.stateAfterText }}
                                    </span>
                                    <div class="comment" v-if="item.userComment">
                                        审核意见：{{ item.userComment }}
                                    </div>
                                    <div class="download-btn" v-if="item.attachmentUrl">
                                        <span>相关附件：{{ item.fileName }}</span>
                                        <a :href="rootUrl + item.attachmentUrl" :download="rootUrl + item.attachmentUrl"
                                            target="_blank">
                                            下载
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <!-- 评价记录 -->
            <a-tab-pane key="5" tab="评价记录">
                <div class="tabs font" style="padding-right: 20%">
                    <div v-if="rateTotal">
                        <div class="record-box" v-for="(item, index) in rateList" :key="index">
                            <div class="time">
                                <div class="avatar">
                                    <img :src="item.imgUrl || '/course_cover.png'" alt="" />
                                </div>
                                <div class="parent">
                                    <div class="parent-name">家长名字</div>
                                    <div class="date">{{ item.gmtCreate }}</div>
                                </div>
                                <div class="rate">
                                    <a-rate :default-value="item.score" disabled />
                                </div>
                            </div>
                            <div class="evaluate">
                                <div class="tags" v-if="item.tagNames">
                                    <div class="tag" v-for="(ele, index) in item.tagNames" :key="index">
                                        {{ ele }}
                                    </div>
                                </div>
                                <p>{{ item.content || "暂无评价描述" }}</p>
                            </div>
                        </div>
                        <a-pagination :default-current="1" v-model="ratePage" :total="rateTotal" :pageSize="10"
                            show-less-items size="small" @change="rateChange" show-quick-jumper />
                    </div>
                    <div class="empty" v-else style="margin-top: 50px">
                        <a-empty><span slot="description">暂无评价</span></a-empty>
                    </div>
                </div>
            </a-tab-pane>
        </a-tabs>
        <!-- 出勤详情窗口 -->
        <a-modal title="出勤详情" width="40%" centered :footer="null" :visible="showAttendance" @cancel="hideAttendance">
            <div class="attendance">
                <!-- <div class="at-item">上课日期：</div>
          <div class="at-item">上课时间：</div> -->
                <div class="at-item">考勤日期：{{ attendanceInfo.date }}</div>
                <div class="at-item">考勤时间：{{ attendanceInfo.time }}</div>
                <div class="at-item">考勤状态：{{ attendanceInfo.statusText }}</div>
                <div class="at-item"></div>
                <div style="margin-bottom: 10px" v-if="attendanceInfo.lat">
                    考勤地点：( {{ attendanceInfo.lat }} , {{ attendanceInfo.lng }} )
                </div>
            </div>
        </a-modal>
    </a-drawer>
</template>

<script>
import moment from "moment";
import teacher from "../../../api/teacher";
import CProgress from "../../../components/CProgress"; // 封面上传
const columns = [
    {
        title: "学历",
        dataIndex: "description",
        scopedSlots: { customRender: "description" },
    },
    {
        title: "毕业院校",
        dataIndex: "text",
        scopedSlots: { customRender: "text" },
    },
    {
        title: "学历证",
        dataIndex: "teaTeacherInfoDos",
        scopedSlots: { customRender: "teaTeacherInfoDos" },
    },

    {
        title: "学位证",
        dataIndex: "teaTeacherInfoDos1",
        scopedSlots: { customRender: "teaTeacherInfoDos1" },
    },
];
const classColumns = [
    {
        title: "班级",
        dataIndex: "className",
    },
    {
        title: "学校",
        dataIndex: "schoolName",
    },
    {
        title: "学期",
        dataIndex: "termName",
    },

    {
        title: "课程",
        dataIndex: "courseName",
    },
    {
        title: "任课类型",
        dataIndex: "teachingType",
    },
    {
        title: "提供方",
        dataIndex: "provider",
    },
    {
        title: "",
        dataIndex: "operate",
        width: 135,
        scopedSlots: { customRender: "operate" },
    },
];
const AttendancesColumns = [
    {
        title: "出勤日期",
        dataIndex: "attendDate",
        scopedSlots: { customRender: "attendDate" },
    },
    {
        title: "签到时间",
        dataIndex: "checkinTime",
    },
    {
        title: "状态",
        dataIndex: "checkinStatusText",
        scopedSlots: { customRender: "checkinStatusText" },
    },

    {
        title: "课程",
        dataIndex: "courseName",
    },
    {
        title: "班级",
        dataIndex: "className",
    },
    {
        title: "学校",
        dataIndex: "schoolName",
    },
    {
        title: "",
        dataIndex: "operate",
        width: 100,
        scopedSlots: { customRender: "operate" },
    },
];
const examineArr = [
    {
        status: "4",
        name: "初审通过",
        iOver: false,
    },
    {
        status: "5",
        name: "复审通过",
        iOver: false,
    },
    {
        status: "1",
        name: "审核通过",
        iOver: false,
    },
    {
        status: "2",
        name: "审核不通过",
        iOver: false,
    },
];
export default {
    name: "TeacherDeatil",
    components: {
        CProgress,
    },
    props: {
        showDrawer: {
            type: Boolean,
            default: false,
        },
        teacherUserId: {
            type: Number,
        },
        readOnly: {
            type: Boolean,
        }
    },
    data() {
        return {
            columns,
            classColumns,
            AttendancesColumns,
            examineArr,
            tabIndex: "1", //tab
            failReason: "", //审核驳回原因
            dataInfo: {}, //统计数据
            isVideo: false, // 显示视频
            isProgress: false,
            talkingVideoUrl: "", // 说课视频url
            status: "", // 选择的审核状态
            currentStatus: "", //当前审核状态
            teacherLesson: [], // 上传附件
            attachmentUrl: "", // 上传附件url
            createdTime: "", //注册日期
            operateTime: "", //审核通过日期
            reviewer: "", //审核方
            teacherDetail: {
                degreeCertificatList: [],
            },
            credentialUrls: [], // 老师资质url
            checkOperateLogArr: [], // 审核记录
            degreeCertificatArr: [],
            degreeCertificatList: [], //学历学位表
            protraitPhotoUrl: "", // 免冠照片url
            noCriminalUrl: "", // 无犯罪证明url
            noCriminalDate: '', // 无犯罪证明有效期
            classData: [], //任课班级数据
            classPagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                size: "small",
                showQuickJumper: true,
            },
            attendanceData: [], //出勤记录数据
            attendanceInfo: {}, //出勤详情
            attendancePagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                size: "small",
                showQuickJumper: true,
            },
            showAttendance: false, //显示出勤
            ratePage: 1, //当前评价页
            rateTotal: 0, //评价总数
            rateList: [], //评价内容
        };
    },
    created() {
        this.getTeacher();
        this.getHostUrl();
    },
    mounted() { },
    methods: {
        // 关闭详情抽屉
        close() {
            this.$emit("update:showDrawer", false);
        },
        // 点击查看说课视频
        showVideo() {
            this.isVideo = true;
        },
        // 关闭说课视频
        videoCancel() {
            this.isVideo = false;
            this.$refs.videoPlay.pause();
        },
        getHostUrl() {
            this.rootUrl = globalConfig.rootBureauUrl + "/api/bureau/aliyun/getFile?url=";
        },
        //隐藏
        handleCancel() {
            this.examineArr.forEach((v) => {
                v.iOver = false;
            });
            // this.status = ''
            this.visible = false;
        },
        //师资详情
        getTeacher() {
            teacher.getTeacher(this.teacherUserId).then((res) => {
                this.teacherDetail = res.data;
                this.createdTime = res.data.gmtCreate;
                this.noCriminalDate = res.data.noCriminalDate ? moment(res.data.noCriminalDate) : '';
                // console.log("老师详情", this.teacherDetail);
                if (this.teacherDetail.intro) {
                    this.teacherDetail.intro = res.data.intro;
                }
                this.status = res.data.status;
                this.getCheckOperateLog(res.data.id);
                this.getTeacherData(res.data.id, res.data.userId);
                this.getTeacherClasses(res.data.id, res.data.userId, 1);
                this.getTeacherAttendance(res.data.id, res.data.userId, 1);
                this.getTeacherEvaluationRecords(res.data.id, res.data.userId, 1);
                if (this.teacherDetail.degreeCertificatList) {
                    this.degreeCertificatList = res.data.degreeCertificatList
                        .filter((i) => i.teaTeacherInfoDos && i.teaTeacherInfoDos.length)
                        .map((item) => {
                            var result = {
                                teaTeacherInfoDos1: item.teaTeacherInfoDos,
                                ...item,
                            };
                            result.teaTeacherInfoDos1.imgSrc1 = this.backUrl(
                                result.teaTeacherInfoDos1,
                                1
                            );
                            result.teaTeacherInfoDos.imgSrc0 = this.backUrl(
                                result.teaTeacherInfoDos,
                                0
                            );
                            return result;
                        });
                    // console.log("学历学位表", this.degreeCertificatList);
                }
                this.degreeCertificatArr = [...new Set(this.degreeCertificatArr)];
                if (this.teacherDetail.noCriminalUrl) {
                    this.noCriminalUrl = this.teacherDetail.noCriminalUrl[0].fileUrl;
                }
                if (this.teacherDetail.protraitPhotoUrl) {
                    this.protraitPhotoUrl =
                        this.teacherDetail.protraitPhotoUrl[0].fileUrl;
                }
                if (this.teacherDetail.talkingVideoUrl) {
                    this.talkingVideoUrl = this.teacherDetail.talkingVideoUrl[0].fileUrl;
                }
                if (
                    this.teacherDetail.healthCertificateUrl != null &&
                    this.teacherDetail.healthCertificateUrl.length != 0
                ) {
                    this.healthCertificateUrl = this.teacherDetail.healthCertificateUrl;
                }
                if (
                    this.teacherDetail.credentialUrls != null &&
                    this.teacherDetail.credentialUrls.length != 0
                ) {
                    this.credentialUrls = this.teacherDetail.credentialUrls;
                }
            });
        },
        backUrl(list, type) {
            if (!list.length) return "";
            const filterList = list.filter((item) => item.extType === type);
            if (!filterList.length) return "";
            return filterList[0].fileUrl;
        },
        // 数据统计
        getTeacherData(teacherId, userId) {
            teacher.getTeacherData({ teacherId, userId }).then((res) => {
                this.dataInfo = res.data;
                // console.log(this.dataInfo, "数据统计");
            });
        },
        // 任课班级
        getTeacherClasses(teacherId, userId, currentPage) {
            teacher
                .getTeacherClasses({ teacherId, userId, currentPage })
                .then((res) => {
                    // console.log(res, "任课班级");
                    this.classData = res.data.records;
                    this.classPagination.total = res.data.total;
                });
        },
        classChange(e) {
            this.classPagination.current = e.current;
            this.getTeacherClasses(
                this.teacherDetail.id,
                this.teacherDetail.userId,
                e.current
            );
        },
        // 查看班级详情
        viewClassDetail(item) {
            window.open(`${window.location.origin}/#/classDetail?id=${item.classId}&courseId=${item.courseId}&back=list`, "_blank");
        },
        // 出勤记录
        getTeacherAttendance(teacherId, userId, currentPage) {
            teacher
                .getTeacherAttendance({ teacherId, userId, currentPage })
                .then((res) => {
                    // console.log(res, "出勤记录");
                    this.attendanceData = res.data.records;
                    this.attendancePagination.total = res.data.total;
                });
        },
        attendanceChange(e) {
            this.attendancePagination.current = e.current;
            this.getTeacherAttendance(
                this.teacherDetail.id,
                this.teacherDetail.userId,
                e.current
            );
        },
        getRowKey(record, index) {
            return index;
        },
        // 查看考勤详情
        viewAttendanceDetail(e) {
            this.showAttendance = true;
            if (e.teacherCheckinId) {
                teacher.getTeacherCheckinInfo(e.teacherCheckinId).then((res) => {
                    this.attendanceInfo = res.data;
                    this.attendanceInfo.statusText = e.checkinStatusText;
                    this.attendanceInfo.time = e.checkinTime;
                    this.attendanceInfo.date = e.attendDate;
                });
            }
        },
        hideAttendance() {
            this.showAttendance = false;
            this.attendanceInfo = {};
        },
        // 评价记录
        getTeacherEvaluationRecords(teacherId, userId, currentPage) {
            teacher
                .getTeacherEvaluationRecords({
                    teacherId,
                    userId,
                    currentPage,
                    pageSize: 10,
                })
                .then((res) => {
                    this.rateList = res.data.records;
                    this.rateTotal = res.data.total;
                });
        },
        // 评价下一页
        rateChange(e) {
            this.ratePage = e;
            this.getTeacherEvaluationRecords(
                this.teacherDetail.id,
                this.teacherDetail.userId,
                e
            );
        },
        // 修改
        edit() {
            this.$emit('edit', this.teacherUserId)
            this.$nextTick(() => {
                this.close()
            })
        },
        del() {
            let _this = this
            this.$confirm({
                title: '确定要删除吗?',
                okText: '确定',
                cancelText: '取消',
                content: '删除后，无法撤销',
                onOk() {
                    teacher.batchDelete({ ids: _this.teacherUserId }).then((res) => {
                        _this.$message.success('删除成功')
                        _this.close()
                        _this.$emit('refresh')
                    })
                },
            })
        },
        // 提交审核按钮
        submit() {
            teacher.submitTeacher(this.teacherDetail.id).then((res) => {
                this.$message.success('提交审核成功')
                this.getCheckOperateLog(this.teacherDetail.id)
                this.$emit('refresh')
                // this.teacherDetail.status = 0
            })
        },
        // 获取老师审核状态
        getCheckOperateLog(teacherId) {
            teacher.getCheckOperateLogBureau(teacherId).then((res) => {
                let temp = res.data.checkOperateLogDos[0];
                if (temp) {
                    this.currentStatus = temp.stateAfterText;
                    if (temp.stateAfter == 1) {
                        const regex =
                            /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(.*)将审核状态改为/;
                        this.operateTime = temp.createTime;
                        this.reviewer = temp.operateLog.match(regex)[1].trim();
                    }
                } else {
                    this.currentStatus = res.data.status == 0 ? '待审核' : res.data.status == 1 ? '审核通过' : res.data.status == 2 ? '审核不通过' : res.data.status == 3 ? '待提交': res.data.status == 4 ? '初审通过': res.data.status == 5 ? '复审通过' : ''
                }
                
                res.data.checkOperateLogDos.forEach((v) => {
                    if (v.attachmentUrl) {
                        let fileArr = v.attachmentUrl.split("_");
                        if (fileArr.length > 2) {
                            v.attachmentUrl = encodeURIComponent(fileArr.join("_"));
                            let temp = "";
                            fileArr.shift();
                            temp = fileArr.join("_");
                            v.fileName = temp;
                        } else if ((fileArr.length = 2)) {
                            v.attachmentUrl = `${encodeURIComponent(fileArr[0])}_${fileArr[1]
                                }`;
                            v.fileName = fileArr[1];
                        } else {
                            v.attachmentUrl = encodeURIComponent(v.attachmentUrl);
                        }

                        if (v.fileName == undefined) {
                            v.fileName = "无附件名";
                        }
                    }
                });
                this.checkOperateLogArr = res.data.checkOperateLogDos;
                // console.log(this.checkOperateLogArr);
            });
        },
    },
    // 注册时间过滤器
    filters: {
        formatDate(date) {
            return (
                date.substring(0, 4) +
                "年" +
                date.substring(5, 7) +
                "月" +
                date.substring(8, 10) +
                "日"
            );
        },
    },
};
</script>

<style lang="less" scoped>
::v-deep .ant-drawer-body {
    padding: 0;
}

::v-deep .ant-divider {
    margin: 10px 0;
    background-color: #f0f3fb !important;
}

.font {
    font-family: PingFangSC, PingFang SC;
}

.header {
    background-color: #f1fafc;
    padding: 21px 24px 16px;

    .header-top {
        display: flex;

        .avatar {
            width: 52px;
            height: 52px;
            margin-right: 12px;

            a {
                .teacher-left {
                    width: 52px;
                    height: 52px;
                    border-radius: 50%;
                    border: #333 1px;
                }
            }
        }

        .export {
            margin-right: 20px;
            display: flex;

            button {
                margin-left: 12px;
            }
        }

        .close {
            width: 22px;
            height: 30px;
            line-height: 30px;

            img {
                width: 20px;
                height: 20px;
            }
        }

        .teacher {
            flex: 1;

            .name {
                color: #1b1d26;
                height: 22px;
                font-size: 16px;
                margin-top: 6px;
                font-weight: 600;
            }

            .date {
                margin-top: 4px;
                height: 14px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(23, 26, 29, 0.6);
                line-height: 14px;
            }
        }
    }
}

.header-bottom {
    display: flex;
    margin-top: 28px;

    .teacher-detail {
        margin-right: 50px;
        color: #000;

        .text {
            height: 12px;
            color: #37405f;
            line-height: 12px;
            font-size: 12px;
            margin-bottom: 4px;
        }

        .number {
            font-weight: 600;
            font-size: 16px;
            height: 22px;
            line-height: 22px;
            display: flex;
            align-items: center;

            span {
                font-size: 12px;
                line-height: 12px;
            }
        }
    }
}

.green {
    color: #37c894;
    margin-left: 5px;
}

.red {
    color: #ff0000;
    margin-left: 5px;
}

// tab栏
::v-deep .ant-tabs-tab {
    padding: 12px 24px;
    margin: 0;
    bottom: 0px;
}

.description {
    line-height: 12px;
    transform: translateY(15px);
}

::v-deep .ant-tabs-bar {
    border-bottom: none;
    position: relative;
}

::v-deep .ant-tabs-nav-wrap:before {
    content: "";
    position: absolute;
    top: 40px;
    left: 0;
    height: 4px;
    width: 100%;
    z-index: 0;
    background-color: #edf3ef;
}

::v-deep .ant-tabs-ink-bar {
    height: 4px;
    margin-left: 24px;
    width: 56px !important;
    z-index: 1;
}

::v-deep .ant-tabs-tab-active:after {
    content: "";
    position: absolute;
    top: 40px;
    left: 0;
    height: 4px;
    width: 100%;
    background-color: #edf3ef;
}

::v-deep .ant-table-thead th {
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #171a1d;
    line-height: 12px;
    padding: 16px;
}

::v-deep .ant-table-tbody td {
    line-height: 12px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #171a1d;
    padding: 16px;
}

.tabs {
    padding: 14px 24px;
    height: calc(100vh - 214px);
    overflow: auto;
}

.tabs::-webkit-scrollbar {
    display: none;
}

.base-information {
    display: flex;
    width: 90%;
    margin-bottom: 24px;

    .avatar {
        width: 120px;
        margin-right: 32px;
        display: flex;
        align-items: center;

        a {
            img {
                width: 120px;
                height: 120px;
                border-radius: 50%;
            }
        }
    }

    .information-box {
        display: flex;
        flex: 1;
        justify-content: space-between;
    }

    .information {
        padding-top: 11px;

        div {
            min-width: 205px;
            max-width: 450px;
            font-size: 14px;
            height: 22px;
            line-height: 22px;
            margin-bottom: 16px;
            color: #606266;

            // overflow: hidden;
            .infor {
                font-weight: 500;
                color: #35383e;
            }
        }
    }
}

.video {
    display: block;
    width: 120px;
    padding: 2px;
    border: solid 1px #9e9e9e;
    border-radius: 20px;
    margin: -10px 0 14px 0;
    color: #000000A6;
    img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }
}

// 说课视频大小
.videoSize {
    width: 100%;
    height: 350px;
}

.introduction {
    .title {
        margin-bottom: 16px;
        font-weight: bold;
        color: #000;
        font-size: 16px;
    }

    p {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #606266;
        line-height: 19px;
        padding-bottom: 14px;
    }
}

.edu-pic {
    width: 100px;
    height: 50px;

    a {
        width: 100%;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

::v-deep .ant-table-align-center {
    padding: 10px 20px;
}

// 资质证照
.in-item {
    border-bottom: 1px solid #f0f3fb;
    margin-top: 24px;
    padding-bottom: 10px;

    >.key {
        color: rgba(0, 0, 0, 0.85);
        font-size: 16px;
        font-weight: 600;
    }

    >.value {
        font-size: 14px;
        color: #606266;
        margin-top: 10px;

        .item {
            display: inline-block;
            vertical-align: top;

            .ant-table-wrapper {
                margin-bottom: 16px;

                img {
                    width: 80px;
                    height: 45px;
                    margin: 0;
                }
            }

            >.key {
                display: inline-block;
                width: 160px;
                text-align: right;
                font-size: 14px;
                color: #606266;
            }

            >.value {
                color: #35383e;
                font-weight: 500;

                >img {
                    vertical-align: top;
                    width: 160px;
                    height: 90px;
                }
            }

            >.img-box {
                display: block;
                margin-left: 160px;
                margin-top: -21px;
                border-radius: 4px;
            }

            img {
                width: 320px;
                height: 180px;
                vertical-align: top;
                margin-right: 16px;
                margin-bottom: 16px;
                border-radius: 4px;
            }
        }

        .item-33 {
            width: 33%;
        }

        .item-40 {
            width: 34%;
        }

        .item-1 {
            width: 100%;
        }

        .item-placeRemark {
            padding-right: 30%;
        }

        .item-intor {
            padding-right: 30%;
            color: #606266 !important;
        }
    }

    .process {
        width: 900px;
        height: 100%;
        overflow: auto;
        margin-left: 52px !important;
        margin-top: 19px !important;

        &-item {
            margin-bottom: 10px !important;

            .operate {
                color: #c0c4cc;
                margin-left: 26px;
            }

            // 审核意见
            .comment {
                color: #333;
                margin-left: 30px;
            }

            // 下载附件
            .download-btn {
                color: #333;
                margin-left: 30px;

                a {
                    margin-left: 20px;
                }
            }
        }

        li:before {
            content: "";
            width: 4px;
            height: 4px;
            display: inline-block;
            border-radius: 50%;
            background: #bdbdbd;
            vertical-align: middle;
        }
    }

    // 审核通过颜色
    .exa1 {
        color: #19ca3c;
    }

    // 审核驳回颜色
    .exa2 {
        color: #f95050;
    }

    // 初审、复审颜色
    .exa3 {
        color: #ffa91f;
    }
    // 待审核、待提交颜色
    .exa4 {
        color: #000;
    }
}

.teacher-info {
    padding-bottom: 20px;
}

.in-item:last-child {
    border-bottom: none;
}

.in-item:first-child {
    margin-top: 0px !important;
}

.Attendances {
    display: flex;
    color: #000;
    margin-bottom: 25px;

    .attend-data {
        margin-right: 50px;
    }

    p {
        font-size: 16px;
    }

    .attend-number {
        font-size: 18px;
        font-weight: bold;
        margin-top: 5px;
    }
}

.error {
    color: #ff0000;
}

.waitting {
    color: #9e9e9e;
}

// 审核/评价记录
.record-box {
    border-bottom: solid 1px #edf3ef;
    margin-bottom: 24px;

    .time {
        display: flex;
        margin-bottom: 12px;

        .avatar {
            width: 36px;
            height: 36px;
            margin-right: 12px;

            img {
                width: 36px;
                height: 36px;
                border-radius: 50%;
            }
        }

        .parent {
            flex: 1;
            height: 20px;
            font-size: 14px;
            line-height: 20px;

            .parent-name {
                color: #333333;
            }

            .date {
                color: #747677;
            }
        }

        ::v-deep .ant-rate-star {
            transform: scale(0.8) !important;
            margin-right: 0;
        }
    }
}

.evaluate {
    margin-bottom: 16px;
    font-size: 14px;
    color: #1b1d26;
    line-height: 20px;

    .tags {
        display: flex;
        flex-wrap: wrap;

        .tag {
            padding: 6px 20px;
            border-radius: 32px;
            margin-bottom: 10px;
            margin-right: 10px;
            background-color: #f5faf6;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            color: #3c454c;
            line-height: 20px;
        }
    }

    p {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
    }
}

.textarea-form {
    margin: 0px !important;
}

// .value-resolve {
//     color: #37c847 !important;
// }

// .value-rejected {
//     color: #f54d15 !important;
// }

// .value-examine {
//     color: #ffa91f !important;
// }

.attendance {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;

    .at-item {
        width: 50%;
        margin-bottom: 10px;
    }
}

::v-deep .ant-btn-dashed {
    i {
        transform: translate(-2px, 0px);
    }

    span {
        transform: translate(-5px, -1px);
    }
}

::v-deep .ant-table-thead th,
::v-deep .ant-table-tbody td {
    padding: 16px !important;
}
</style>